import GetPagedHydrantListRequestModelBase from '../_generated/modelBases/get-paged-hydrant-list-request-model-base';

export default class GetPagedHydrantListRequestModel extends GetPagedHydrantListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
